export default __webpack_public_path__ + "static/media/site-icon.507b3852.svg";